/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const CART_BASE_FEATURE = 'cartBase';
export const CART_BASE_CORE_FEATURE = 'cartBaseCore';

export const MINI_CART_FEATURE = 'miniCart';
export const ADD_TO_CART_FEATURE = 'addToCart';
